import {
  IBodyProductDownloadSearch,
  IInitialCatalogDownloadState,
} from 'interfaces/catalogDownload.interface';
import { ITableColumnsSelectOrderState } from 'interfaces/tables.interface';

const initialColumnsOrder: Record<string, ITableColumnsSelectOrderState> = {
  brand: { show: true, required: true, order: 0 },
  reference: { show: true, required: true, order: 1 },
  color_code: { show: true, required: true, order: 2 },
  color: { show: true, required: false, order: 3 },
  size: { show: true, required: true, order: 4 },
  ean: { show: true, required: true, order: 5 },
  name: { show: false, required: false, order: 6 },
  pvi: { show: true, required: false, order: 7 },
  pvpr: { show: true, required: false, order: 8 },
  division: { show: false, required: false, order: 9 },
  gender: { show: false, required: false, order: 10 },
  season: { show: false, required: false, order: 11 },
  segmentation: { show: false, required: false, order: 12 },
  family: { show: false, required: false, order: 13 },
  material: { show: false, required: false, order: 14 },
  images: { show: true, required: false, order: 15 },
};

const body: IBodyProductDownloadSearch = {
  options: {
    brand_id: [],
    client_id: '',
    not_downloaded: false,
    favorite: null,
    with_images: null,
    search: [],
    order: [],
    limit: 10,
    index: 0,
  },
  filter: {
    reference: [],
    color: [],
    season: [],
    segmentation: [],
    division: [],
    family: [],
    gender: [],
    pvi: [],
    pvpr: [],
    tag: [],
    tier: [],
    bill: [],
    order: [],
  },
};

const initialCatalogDownloadState: IInitialCatalogDownloadState = {
  // Filters
  catalogBodyFetch: body,
  filters: [],
  imageSelection: 'all',
  setImageSelection: () => {},
  setFavorites: () => {},
  setNotDownloaded: () => {},
  setPviSlider: () => {},
  setPvprSlider: () => {},
  isLoadingFilters: false,
  filtersAlert: {
    description: '',
    message: '',
    show: false,
    type: 'info',
  },
  filtersSelected: null,
  isLoadingCatalog: false,
  filteredList: {
    total: 0,
    of: 0,
    count: 0,
    data: [],
  },
  setFilteredList: () => {},
  handlePagination: () => Promise.resolve(false),
  selectedValues: [],
  setSelectedValues: () => {},
  filtersSelectedTags: [],
  isOpenFilters: true,
  filtersSelectedTemp: null,
  openFilters: () => {},
  cancelFilters: () => {},
  cleanFilters: () => {},
  applyFilterChanges: () => Promise.resolve(false),
  onChangeFilterSelect: () => {},
  // Search
  querySearch: '',
  setQuerySearch: () => {},
  applySearch: () => Promise.resolve(false),
  // Columns
  columnsOrder: initialColumnsOrder,
  moveColumnsOrder: () => {},
  checkColumn: () => {},
  // Download
  downloadingStatus: {
    isDownloading: false,
    totalImagesToDownload: 0,
    completedDownloads: 0,
  },
  downloadCatalog: () => {},
  cancelDownloadCatalog: () => {},
  isDownloadingZip: false,
  downloadImages: true,
  setDownloadImages: () => {},
  xhrsRef: [],
};

export default initialCatalogDownloadState;
